App.D.ready(() => {
    if (App.H.hasClass("page-about-tumodo")) {
        App.H.removeClass("_noscroll");
        window.scrollTo(0, 0);
        App.W.scrollTop(0);
        $("html, body").animate({ scrollTop: 0 }, 100);
        setTimeout(() => {
            window.scrollTo(0, 0);
            App.W.scrollTop(0);
            $("html, body").animate({ scrollTop: 0 }, 50);
        }, 100);
        setTimeout(() => {
            App.H.addClass("_noscroll");
        }, 150);
    }

    if ($(".about-animation--tumodo").length ) {
        let lottieAnimation = document.querySelector("#about-lottie-tumodo");

        lottieAnimation.addEventListener("load", () => {
            $(".about-start").addClass("_lottie-loaded");
        });
        lottieAnimation.addEventListener("complete", () => {

            if ($(".about-animation--tumodo").data('opacity')) {
                $(".about-animation--tumodo").css('opacity', $(".about-animation--tumodo").data('opacity'));
            }

            App.H.removeClass("_noscroll");

            $(".about-start").addClass("_logo-shown");
            $(".about-animation--tumodo").addClass("_finished");

        });

        $('.about-tumodo-line').find('.about-tumodo-line__item').each(function(index, player) {
            LottieInteractivity.create({
                player: player,
                mode: 'scroll',
                actions: [
                    {
                        visibility: [0, 0.9],
                        type: 'seek',
                        frames: [0, 210],
                    },
                ]
            });
        });
    }
});
